import type { ChargerHealth, ChargerTileState } from "../types/charger";
import type { ChargerTileMv } from "../types/dashboard";
import { normalizeChargerLabel, serverHealthToTileHealth } from "./chargerMock";

function healthForId(
  health: Record<string, "ok" | "new" | "stale"> | undefined,
  id: string,
): ChargerHealth {
  const fromServer = serverHealthToTileHealth(health, id);
  if (fromServer) return fromServer;
  return "ok";
}

function ringFromMv(mv: ChargerTileMv | undefined): ChargerTileState["ring"] {
  if (!mv) return "none";
  if (mv.charging) return "blue";
  if (mv.ev_connected) return "green";
  return "none";
}

export function buildChargerTileState(
  id: string,
  health: Record<string, "ok" | "new" | "stale"> | undefined,
  mv: ChargerTileMv | undefined,
  lbIds?: ReadonlySet<string> | null,
): ChargerTileState {
  const label = normalizeChargerLabel(id);
  return {
    id,
    label,
    health: healthForId(health, id),
    evConnected: mv?.ev_connected ?? false,
    charging: mv?.charging ?? false,
    mv5: mv?.mv5 ?? false,
    fcrActivated: Boolean(lbIds?.has(label) || lbIds?.has(id)),
    sp: false,
    resp: false,
    ring: ringFromMv(mv),
    powerGauge:
      mv?.charging || mv?.ev_connected
        ? {
            current: mv.power_current_kw ?? 0,
            max: mv.power_max_kw ?? null,
          }
        : null,
  };
}

export function buildChargerTileStates(
  ids: string[],
  health: Record<string, "ok" | "new" | "stale"> | undefined,
  tiles: Record<string, ChargerTileMv> | undefined,
  lbIds?: ReadonlySet<string> | null,
): ChargerTileState[] {
  return ids.map((id) => {
    const label = normalizeChargerLabel(id);
    const mv = tiles?.[label] ?? tiles?.[id];
    return buildChargerTileState(id, health, mv, lbIds);
  });
}
